import RouterSwitch from './RouterSwitch';

export default RouterSwitch;
